module.exports = __webpack_public_path__ + "static/img/mogos_card_roaming_cn.e40bf78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/mogos_card_roaming_cn.png
// module id = 136
// module chunks = 0